import React from 'react';
import '../../styles/PageTransition.css';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children, className = '' }) => {
  return (
    // Fail open: never leave routed content hidden behind an animation gate.
    <div className={`page-transition page-transition--active ${className}`}>
      {children}
    </div>
  );
};

export default PageTransition;
